import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';
import { History } from 'history';

import User from '../../../models/User';
import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import PickupOrderGha from '../../../models/PickupOrderGha';
import { DelivererType } from '../../../models/DelivererType.enum';

import moment from 'moment';
import queueRemote from '../../../api/queueRemote';
import DriverQueue from '../../../models/DriverQueue';
import PaymentsModal from './AdditionalPayments';
import cartRemote from '../../../api/cartRemote';
import Cart from '../../../models/Cart';
import { deleteAwbFromCart, updateWholeCart } from '../../../store/actions/cartAction';
import { findCartItemByCodeAndNumber } from '../../../utils/cartService';
import PickupOrder from '../../../models/PickupOrderGha';
import Awb from '../../../models/Awb';
import AlternativePaymentOptions from '../../../models/PaymentOptions';
import paymentsRemote from '../../../api/paymentsRemote';
import AdditionalServicesModalContainer from '../../cart/additionalServices/additionalServicesModal/AdditionalServicesModalContainer';

interface MissingPaymentModalContainerProps {
  receiveError: (error: any) => void;
  user: User;
  awbNumber: string;
  modalOpen: boolean;
  history: History;
  awb: Awb;
  cart: Cart;
  handleCloseModal: (type: string) => void;
  updateCart: Function;
  // order: PickupOrder;
  deleteAwbFromCart: Function;
  selectedAwbNumber: string;
  selectedAwbCode: string
};

interface MissingPaymentModalContainerState {
  delivererType: string;
  returnCharges: string;
  paymentInfoSelect: string;
  paymentOptions: AlternativePaymentOptions;
  paymentType: string;
  showText: boolean;
  navigate: boolean
  addServicesModalOpen: boolean;
};

class MissingPaymentModalContainer extends Component<MissingPaymentModalContainerProps, MissingPaymentModalContainerState> {

  state: MissingPaymentModalContainerState = {
    paymentType: '',
    paymentInfoSelect: '',
    delivererType: DelivererType.FORWARDER,
    returnCharges: '',
    paymentOptions: {} as AlternativePaymentOptions,
    showText: false,
    navigate: false,
    addServicesModalOpen: false
  }

  componentDidMount() {
    this.getAltPaymentOptions();
  }

  closeModal = (type: string) => {
    if(type === 'missing_payment') {
      this.props.deleteAwbFromCart(this.props.awb.code, this.props.awb.number);
      this.props.handleCloseModal(type);
    } else {
      this.props.handleCloseModal('missing_payment');
    }
  }



  handleChange = (propertyName: string, event: any): void => {

    let value: any = event.target.value;

    // const driverInfo: DriverInfoModel = { ...this.state.driverInfo };
    // const returnDetails = { ...this.state.returnDetails }
    let returnCharges = this.state.returnCharges;
    let paymentInfoSelect = this.state.paymentInfoSelect;
    switch (propertyName) {
      case 'returnCharges': returnCharges = value ; break;
      case 'paymentInfoSelect': paymentInfoSelect = value; break;
      // case 'reason': returnDetails.reason = value ; break;
      // case 'pieces': returnDetails.pieces = Number(value) ; break;
      // case 'weight': returnDetails.weight = Number(value) ; break;
      default: break;
    }

    if (propertyName !== 'arrivalTime') {
      this.setState({ returnCharges, paymentInfoSelect });
    }
  }

  deleteItemOfDriverInQueue = async (driverId: number): Promise<void> => {

    try {
      const resp: ApiResponse<Array<DriverQueue>> = await queueRemote.deleteDriverOfQueue(driverId)
    }
    catch (error) {

      return this.props.receiveError(error);
    }
  }

  handleSubmit = async (): Promise<void> => {

    if(this.state.navigate) {
      this.props.history.push('/manage-imports');
    } else {
      const isValid: boolean = this.isValid();
      let paymentOther = this.state.paymentInfoSelect === 'other' ?  this.state.returnCharges : this.state.paymentInfoSelect;
      if (!isValid) {
  
        let apiResponseOrder: ApiResponse<PickupOrderGha>;
        this.setState({ showText: true, navigate: true });
        setTimeout(() => {
          this.setState({ showText: false });
        }, 3000);
        // try {
        //   apiResponseOrder = await cartRemote.returnPay(true, driverInfo, this.state.returnDetails, this.props.awb, paymentOther);
  
        //   if (apiResponseOrder.result) {
           
        //   }
  
        //   if (apiResponseOrder.error) {
        //     this.props.receiveError(apiResponseOrder.error);
        //   }
        // } catch (error) {
        //   return this.props.receiveError(error);
        // }
      }
    }
  }

  getAltPaymentOptions = (): void => {

    paymentsRemote.getPaymentOptions().then((resp: ApiResponse<AlternativePaymentOptions>) => {

      const paymentOptions: AlternativePaymentOptions | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      
      if (paymentOptions) {
        this.setState({ paymentOptions })
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleClose = (): void => {
    this.setState({ addServicesModalOpen: false});
  }

  // closeModal = (): void => {

  // }

  handleOpenModal = (): void => {
    this.setState({ addServicesModalOpen: true});
  }

  isValid = (): boolean => {
    let hasError: boolean = false;
    if(this.state.returnCharges === '' && this.state.paymentInfoSelect === '') {
      hasError = true;
    }

    return hasError;
  }


  addToCart = () => {

    cartRemote.addAirwayBillToReturnCart(this.props.awb.code, this.props.awb.number, this.props.awb.version).then((resp: ApiResponse<Cart>) => {

      const cart: Cart | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      const cartItemsLength: number = (cart && cart.cart) ? cart.cart.length : 0;

      if (cart) {
        this.props.updateCart(cart);
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }
   
  render () {
    return (
      <React.Fragment>
        <PaymentsModal 
          modalOpen={ this.props.modalOpen }
          handleCloseModal={ this.closeModal }
          handleChange={ this.handleChange }
          handleSubmit={ this.handleSubmit }
          history={this.props.history}
          handleOpenModal={ this.handleOpenModal }
          returnCharges={ this.state.returnCharges }
          cartItem={ findCartItemByCodeAndNumber(this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.cart) }
          paymentInfoSelect={ this.state.paymentInfoSelect }
          paymentOptions={ this.state.paymentOptions }
          paymentType={ this.state.paymentType }
          showText={ this.state.showText }
          orderNumber={ this.props.awb.order_number }
        />
         { this.state.addServicesModalOpen &&
           <AdditionalServicesModalContainer
            modalOpen={ this.state.addServicesModalOpen }
            handleClose={ this.handleClose }
            selectedAwbCode={ this.props.awb.code }
            selectedAwbNumber={ this.props.awb.number }
            selectedAwbVer={ this.props.awb.version }
          />
        }
      </React.Fragment>

    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    cart: state.cart
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    updateCart: (cart: Cart) => dispatch(updateWholeCart(cart)),
    deleteAwbFromCart: (awbCode: string, awbNumber: string) => dispatch(deleteAwbFromCart(awbCode, awbNumber)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MissingPaymentModalContainer);
